// Imports
import { Component, OnInit } from '@angular/core';
import { Constant } from "../../constant";
import { DataService } from '../../service/data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UserProfile } from '../../models/users.model';
declare let $: any;
// Component Decorator
@Component({
  selector: 'feature-maintenance',
  templateUrl: './feature-maintenance.component.html',
  styleUrls: ['./feature-maintenance.component.scss']
})

// Component Class
export class FeatureMaintenanceComponent implements OnInit{
  public Constant = Constant;
  resource: any = {};
  geolocation: any;
  isVietNam: boolean = true;
  backgroundImage: string  = '/assets/images/503/image-tinhnangbiloi.png';
  text: string = 'Tính năng đang gặp trục trặc kỹ thuật';
  width: number = 431;
  height: number = 248;
  userProfile: UserProfile;
  constructor(
      public dataService: DataService,
      public router: Router,
      public sanitizer:DomSanitizer,
      private route: ActivatedRoute,
  ) {

  }
  ngOnInit() {
    this.checkPage();
  }
  checkPage() {
    const params = this.route.snapshot.queryParams;
    const type = params.type;
    switch (type) {
      case 'robo':
        this.backgroundImage = '/assets/images/503/kien-error.png';
        this.text = 'RoboF tạm thời đang được nâng cấp';
        this.width = 312;
        this.height = 269;
      break;
    }
  }
}